import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgWizardService } from "ng-wizard";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
// import { AlertService } from "src/app/services/alert/AlertService";

@Component({
  selector: 'app-quiz-task-list',
  templateUrl: './quiz-task-list.component.html',
  styleUrls: ['./quiz-task-list.component.scss']
})
export class QuizTaskListComponent implements OnInit {
  enagagementDeatail: any = [];
  formGroup;
  getPaginationCount;
  addOrEditCampaign: any;
  deletePopupUiData;
  submitted: boolean = false;
  page: any = 1;
  addOrEditEngagement: string = 'add'



  search = "";
  startDate: any = "";
  endDate: any = "";
  portfolio: any = "";

  constructor(
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public router: Router,
    // public alertService: AlertService,

  ) { }

  ngOnInit() {
    this.getEngagementsList();
  }

  get f() {
    return this.formGroup.controls;
  }

  addQuiz(addOrEdit,data?) {
    let engagementId
    this.addOrEditEngagement = addOrEdit
    let engagementStepFlags = {
      createEngagementFlag : addOrEdit == 'add' ? true : true,
      whitelistFlag : addOrEdit == 'add' ? false : true
    }
    let engagementDetail = {
      task_id : addOrEdit == 'edit' ? data.task_id : "",
      engagement_type_id : addOrEdit == 'edit' ? data.engagement_type_id : "",
      portfolio_id : addOrEdit == 'edit' ? data.portfolio_id : "",
      is_edit : addOrEdit == 'edit' ? true : false ,
      start_date : addOrEdit == 'edit' ? data.start_date : "",
      end_date : addOrEdit == 'edit' ? data.end_date : "",
      whitelist_type: addOrEdit == 'edit'? data.whitelist_type:'',
      zone_type : addOrEdit == 'edit'? data.zone_type:'',
      role_type : addOrEdit == 'edit'? data.role_type:'',
      zone_id : addOrEdit == "edit" ? data.zone_id:'',
    }
    addOrEdit === 'edit' ? engagementId = data.task_id : engagementId =  0
    localStorage.setItem("engagementStepFlags", JSON.stringify(engagementStepFlags))
    localStorage.setItem("engagementDetail", JSON.stringify(engagementDetail))
    this.router.navigate(["/hubAdmin/quiz-task-setup/" + engagementId]);
  }

  getEngagementsList() {
    this.apiService.getHeaders(this.apiConfig.engagementList + `?engagement_page=2&page=${this.page}&start_date=${this.startDate}&end_date=${this.endDate}&search=${this.search}&portfolio_id=${this.portfolio}`)
      .subscribe((res: any) => {
        this.enagagementDeatail = res.body.data.data;
        console.log(this.enagagementDeatail)
        this.getPaginationCount = res.body.data.pagination.totalCount

      })
  }
  
  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getEngagementsList();
  }

  reset(){
    this.startDate = ''
    this.endDate = ''
    this.search = ''
    this.getEngagementsList()
  }
}
